import ReactECharts, { type EChartsOption } from "echarts-for-react";
import { get } from "lodash";
import { useMemo } from "react";
import { useTriviaContext } from "../context-trivia";

export function TriviaResulChart() {
  const { screen, questionChoiceIndexes } = useTriviaContext();

  const buttonColorBackground = useMemo<string>(
    () => get(screen, "flyout.post.customData.buttonColorBackground"),
    [screen],
  );
  const buttonColorText = useMemo<string>(
    () => get(screen, "flyout.post.customData.buttonColorText"),
    [screen],
  );
  const questions = useMemo<
    { answers: { answer: string; correct: boolean }[] }[]
  >(() => get(screen, `flyout.post.customData.trivia.questions`, []), [screen]);
  const countQuestions = Array.isArray(questions) ? questions.length : 0;
  const countCorrect = useMemo<number>(
    () =>
      questions.filter(
        (q, index) => !!q?.answers?.[questionChoiceIndexes?.[index]]?.correct,
      ).length,
    [questions, questionChoiceIndexes],
  );

  const option = useMemo<EChartsOption>(
    () => ({
      animation: false,
      responsive: true,
      series: [
        {
          name: "Background",
          type: "pie",
          labelLine: {
            show: false,
          },
          data: [
            {
              value: 1,
              itemStyle: {
                color: buttonColorBackground,
              },
            },
          ],
        },
        {
          name: "Trivia Results",
          type: "pie",
          radius: ["40%", "70%"],
          label: {
            show: true,
            position: "center",
            fontSize: 72,
            color: buttonColorText,
          },
          labelLine: {
            show: false,
          },
          data: [
            {
              value: countQuestions - countCorrect,
              name: `${countCorrect} / ${countQuestions}`,
              itemStyle: {
                color: "#7d0000",
                fontSize: 72,
              },
              label: {
                show: true,
              },
            },
            {
              value: countCorrect,
              itemStyle: {
                color: "#0a7d00",
              },
              label: {
                show: false,
              },
            },
          ],
        },
      ],
    }),
    [countCorrect, countQuestions, buttonColorBackground, buttonColorText],
  );

  return (
    <div className="relative h-full w-full">
      <ReactECharts
        option={option}
        opts={{
          renderer: "canvas",
        }}
        style={{
          height: "100%",
          width: "100%",
        }}
      />
    </div>
  );
}
